<template lang="pug">
    v-form( ref="form" )
        v-container( fluid grid-list-lg )
            v-layout( row wrap )
                v-flex( xs12 )
                    span.title.ma-0 Información general
                v-flex( xs12 sm3 )
                    v-text-field( :disabled="busy" label="Numero del registro" outline readonly v-model="formData.id" )
                v-flex( xs12 sm3 )
                    v-text-field( :disabled="busy" label="Fecha de registro" outline readonly v-model="formData.created_at" )
                v-flex( xs12 sm3 )
                    v-select( :disabled="busy" item-text="type" item-value="id" :items="form.items.conditions" label="Condición de pago" outline readonly v-model="formData.pch_payment_condition_id" )
                v-flex( xs12 sm3 )
                    v-text-field( :disabled="busy" label="Monto" outline prefix="$" readonly v-model="formData.amount" )
                v-flex( xs12 )
                    span.title.ma-0 Detalle
                v-flex( xs12 outline-flex mx-2 mb-4 mt-2 )
                    v-data-table( :headers="headers" :items="items" rows-per-page-text="Documentos por pagina" )
                        template( slot="items" slot-scope="props" )
                            td {{ props.item.sl_customer_account_receivable.sl_sale_invoice.number }}
                            td {{ props.item.sl_customer_account_receivable.sl_sale_invoice.created_at }}
                            td $ {{ props.item.sl_customer_account_receivable.sl_sale_invoice.net_total }}
                            td $ {{ props.item.sl_customer_account_receivable.sl_sale_invoice.iva }}
                            td $ {{ props.item.sl_customer_account_receivable.sl_sale_invoice.total }}
                            td $ {{ props.item.amount }}
                template( v-if="variant === 'verify'" )
                    v-flex( xs12 )
                        span.title.ma-0 Confirmar pago
                    v-flex( xs12 sm4 )
                        v-select( :disabled="busy" item-text="text" item-value="id" :items="form.items.types" label="Tipo de pago" outline v-model="formData.pos_payment_type_id" )
                    v-flex( xs12 sm4 v-if="requiredVoucher" )
                        v-text-field( :disabled="busy" label="Numero de voucher" outline :rules="[ mixRules.required ]" v-model="formData.voucher_number" )
                    v-flex( xs12 sm4 v-if="requiredBank" )
                        v-select( :disabled="busy" item-text="bank" item-value="id" :items="form.items.banks" label="Banco" outline :rules="[ mixRules.required ]" v-model="formData.g_bank_id " )
                    v-flex( xs12 sm4 v-if="requiredBank" )
                        v-text-field( :disabled="busy" label="Numero de cuenta" outline :rules="[ mixRules.required ]" v-model="formData.account_number" )
                    v-flex( xs12 sm3 v-if="requiredBank" )
                        v-text-field( :disabled="busy" label="Plaza" outline :rules="[ mixRules.required ]" v-model="formData.plaza" )
                    v-flex( xs12 sm3 v-if="requiredBank" )
                        v-select( :disabled="busy" item-text="name" item-value="id" :items="form.items.checks" label="Tipo" outline :rules="[ mixRules.required ]" v-model="formData.pos_payment_check_type_id" )
                    v-flex( xs12 sm3 v-if="requiredBank && requiredDate" )
                        v-text-field( :disabled="busy" label="Fecha" outline :rules="[ mixRules.required ]" type="date" v-model="formData.charge_date" )
                    v-flex( xs12 sm3 v-if="requiredBank" )
                        v-text-field( :disabled="busy" label="Numero de serie" outline :rules="[ mixRules.required ]" v-model="formData.serial_number" )
                    v-flex( xs12 mx-0 px-0 text-xs-right v-if="requiredType" )
                        v-btn( @click="submit" color="primary" depressed large :loading="busy" ) confirmar pago
                template( v-else )
                    v-flex( xs12 )
                        span.title.ma-0 Estado del registro
                    v-flex( xs12 sm4 )
                        v-text-field( :disabled="busy" single-line outline readonly :value="item.registered_in_cash_desk ? 'Registrado en caja.' : 'Sin registrar.'" )
                    v-flex( xs12 mx-0 px-0 text-xs-right v-if="canPrint" )
                        v-btn( @click="submitPrint" color="primary" depressed large :loading="busy" ) imprimir comprobante

</template>

<script>
//
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import { mapActions, mapState } from 'vuex'
//
import PaymentVerifyService from '@/services/API/paymentVerify'
//
import PaymentConditionModel from '@/models/Purchase/PchPaymentCondition'
import PaymentTypeModel from '@/models/POS/PosPaymentType'
import BankModel from '@/models/General/GBank'
import PaymentCheckTypeModel from '@/models/POS/PosPaymentCheckType'
//
import InputValidations from '@/mixins/InputValidations'
//
export default {
    computed: {
        /**
         *
         */
        ...mapState(['AuthModule', 'CashDeskModule', 'CashierModule']),

        /**
         *
         */
        canPrint() {
            return this.formData.registered_in_cash_desk === true
        },

        /**
         *
         */
        requiredBank() {
            return this.formData.pos_payment_type_id === 4
        },

        /**
         *
         */
        requiredDate() {
            return this.formData.pos_payment_check_type_id === 1
        },

        /**
         *
         */
        requiredVoucher() {
            return (
                this.formData.pos_payment_type_id === 2 ||
                this.formData.pos_payment_type_id === 3
            )
        },

        /**
         *
         */
        requiredType() {
            return this.formData.pos_payment_type_id !== 0
        },
    },
    data() {
        return {
            busy: false,
            id: '',
            created_at: '',
            pch_payment_condition_id: '',
            form: {
                items: {
                    conditions: [],
                    types: [],
                    banks: [],
                    checks: [
                        {
                            id: 1,
                            name: 'Cheque a fecha',
                        },
                        {
                            id: 2,
                            name: 'Cheque dia',
                        },
                    ],
                },
            },
            formData: {
                account_number: '',
                amount: 0,
                business_name: '',
                charge_date: '',
                g_bank_id: 0,
                plaza: '',
                pos_payment_check_type_id: 0,
                pos_payment_type_id: 0,
                registered_in_cash_desk: false,
                serial_number: '',
                voucher_number: '',
            },
            headers: [
                {
                    text: 'FOLIO',
                    value: 'id',
                },
                {
                    text: 'FECHA DE CREACIÓN',
                    value: 'created_at',
                },
                {
                    text: 'NETO',
                    value: 'net_price',
                },
                {
                    text: 'IVA',
                    value: 'iva',
                },
                {
                    text: 'TOTAL',
                    value: 'total',
                },
                {
                    text: 'MONTO',
                    value: 'amount',
                },
            ],
            items: [],
        }
    },
    props: {
        /**
         *
         */
        item: {
            type: Object,
            default: () => ({
                id: '',
            }),
        },

        /**
         *
         */
        variant: {
            type: String,
            default: 'show',
        },
    },
    methods: {
        /**
         *
         */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
        }),

        /**
         *
         */
        getPayment() {
            //
            const payment_type = this.formData.pos_payment_type_id
            //
            return {
                pos_cash_desk_id: this.AuthModule.cash_desk_id, // ID caja
                g_user_id: this.AuthModule.user.id || 1, // ID cajero
                sl_ground_seller_payment_record_id: this.formData.id,
                payments: [
                    {
                        pos_payment_type_id: this.formData.pos_payment_type_id,
                        amount: this.formData.amount,
                        voucher_number: this.formData.voucher_number,
                        g_bank_id: this.requiredBank
                            ? this.formData.g_bank_id
                            : undefined,
                        account_number: this.requiredBank
                            ? this.formData.account_number
                            : undefined,
                        plaza: this.requiredBank
                            ? this.formData.plaza
                            : undefined,
                        pos_payment_check_type_id: this.requiredBank
                            ? this.formData.pos_payment_check_type_id
                            : undefined,
                        charge_date: this.requiredBank
                            ? this.formData.charge_date
                            : undefined,
                        serial_number: this.requiredBank
                            ? this.formData.serial_number
                            : undefined,
                    },
                ],
            }
        },

        /**
         *
         */
        async reset() {
            //
            this.busy = true
            //
            this.form.items.banks = (await BankModel.params({
                get_all_results: true,
            }).get()).data
            this.form.items.conditions = (await PaymentConditionModel.params({
                get_all_results: true,
            }).get()).data
            this.form.items.types = this.CashDeskModule.paymentMethodsList
            //
            if (this.item.sl_customer) {
                //
                this.formData.id = this.item.id
                this.formData.business_name = this.item.sl_customer.business_name
                this.formData.created_at = this.item.created_at
                this.formData.pch_payment_condition_id = this.item.sl_customer.pch_payment_condition_id
                this.formData.amount = this.item.total
                this.formData.registered_in_cash_desk = this.item.registered_in_cash_desk
                //
                this.items = this.item.sl_detail_ground_seller_payment_records
            }
            //
            this.busy = false
        },

        /**
         *
         */
        showSnackbar(typeMessage, title, body) {
            this.resetSnackbarState()
            this.initSnackbar({
                typeMessage,
                message: {
                    title,
                    body,
                },
                timeout: 5000,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            })
        },

        /**
         *
         */
        async submit() {
            //
            if (this.$refs.form.validate()) {
                //
                const {
                    error,
                    message,
                    status,
                } = await PaymentVerifyService.verify(this.getPayment())
                //
                switch (status) {
                    case 'success':
                        this.showSnackbar(
                            'success',
                            'Éxito.',
                            'Pago verificado.'
                        )
                        this.$emit('success')
                        break
                    case 'error':
                        this.showSnackbar('error', 'Error.', error || message)
                        break
                }
            }
        },

        /**
         *
         */
        submitPrint() {
            PaymentVerifyService.printVerify(this.item.id)
        },
    },
    mixins: [InputValidations],
    mounted() {
        this.reset()
    },
    watch: {
        /**
         *
         */
        item() {
            this.reset()
        },
    },
}
</script>

<style>
.outline-flex {
    border: 2px #727272 solid;
    border-radius: 4px;
}
</style>

